export default "__VITE_ASSET__Dod9jZjM__"